import React from 'react'
import MaterialSymbol from '../material-symbol'

const FileUpload = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="file_upload" {...props} />
))

FileUpload.displayName = 'FileUpload'

export default FileUpload
